export default __webpack_public_path__ + "static/media/icon-ops.fd6ddb92.svg";